export default __webpack_public_path__ + "static/37-375c7964a754c0d16f9c05ec4a12d66f.png";